export enum ZIndex {
  STICKY_TABS = 120,
  STICKY_HEADER = 130,
  SIDEBAR = 1200,
  SIDEBAR_TOGGLE = 1201,
  DIALOG_BELOW_LEGACY_MODALS = 1250,
  FLOATING_BANNER = 1350,
  DIALOG = 1500,
  TOUR_SPOTLIGHT = 1550,
  POPUP = 1600,
  FEEDBACK_BUTTON = 1700, // Marker.io button, hardcoded in packages/frontend/index.html
  SNACKBAR = 1800,
}
